/**
* Team Member Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Team Member Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'team-member-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.team-member-slider__splide' ).each( function( index, element ) {
        const slider = new Splide( $( element )[0], {
          type: 'slide',
          arrows: true,
          pagination: false,
          gap: '2rem',
          perPage: 2,
          breakpoints: {
            1270: {
              perPage: 1,
            },
          },
        } );

        // slider.on( 'overflow', function( isOverflow ) {
        //   slider.options = {
        //     arrows: isOverflow,
        //     drag: isOverflow,
        //   };
        // } );
        slider.mount();
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'team-member-slider', COMPONENT );
} )( app );
